import View from './Feedback';
import enhancer from './Feedback.enhancer';

const Feedback = enhancer(View);

export default Feedback;
